export default __webpack_public_path__ + "static/media/logo_PA.c1667832.svg";